const apiClient = require('@/api/client.js')

export default {

  rateDriver(params, callback) {
    return apiClient.post('/rating/driver', params, callback);
  }

}



// WEBPACK FOOTER //
// ./src/components/tracking-widget/service.js